const TABS_MENU = '.ftbl__tabs-menu--dark';
const INDEX_MENU = '.ftbl__index-menu';
const TAB_CONTENT = '.ftbl__tabs-switch__content';
const FOOTBALL_WEB_COMPONENT = 'ld-football-scores-football-live-score';

const OFFSET_TOP = 64 + 20;
const TABS_HEIGHT = 62;
const OFFSET_BOTTOM = 50;

export function updateTabsPosition() {
  const tabsMenu = document.querySelector<HTMLElement>(TABS_MENU);

  if (!tabsMenu) {
    return;
  }

  const waitTabActivation = () => {
    const activeTab = getActiveTabContent();
    const indexMenu = activeTab?.querySelector(INDEX_MENU);

    if (window.innerWidth < 1024) {
      if (indexMenu) {
        tabsMenu.style.bottom = `${OFFSET_BOTTOM}px`;
      } else {
        tabsMenu.style.bottom = '0';
      }
    }

    const webComponent = activeTab?.querySelector(FOOTBALL_WEB_COMPONENT);

    if (webComponent) {
      // force the web component to scroll in the right position
      webComponent?.setAttribute('visible', 'true');
      window.addEventListener(
        'livescore_widget_mounted',
        () => {
          webComponent?.setAttribute('visible', 'true');
        },
        { once: true }
      );
    } else if (activeTab) {
      const offset = window.innerWidth < 1024 ? OFFSET_TOP : TABS_HEIGHT + OFFSET_TOP;
      const competitionTop = activeTab.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: competitionTop, behavior: 'smooth' });
    }
  };

  setTimeout(waitTabActivation, 0);
}

function getActiveTabContent() {
  return Array.from(document.querySelectorAll<HTMLDivElement>(TAB_CONTENT)).find((el) => el.style.display === 'block');
}
